import React, {useState} from 'react'
import scrollWindowTo from '@helpers/misc/scrollTo'
import useEffect from '@hooks/useEffect'
import useIsStore from '@hooks/useIsStore'
import useRef from '@hooks/useRef'
import classnames from 'classnames'

import Dropdown from './Dropdown'

import styles from './styles.module.css'

export interface Props {
  activeCategoryId: string
  categories: any[]
  layout: string
  onClick: () => void
  scrollTo: (categoryId: string) => void
}

export default function Categories(props: Props) {
  const {activeCategoryId, categories, layout, onClick} = props
  const refs = useRef({})
  const container = useRef(null)
  const isStore = useIsStore()
  const [scrollLeft, setScrollLeft] = useState(0)

  const offsetLeft = {
    v1: 40,
    v2: 50,
    mobile: 50
  }[layout]

  const scrollTo = activeCategoryId => {
    const activeElement = refs.current[activeCategoryId]

    if (!activeElement) return
    scrollWindowTo({
      element: container.current,
      left: activeElement.offsetLeft - offsetLeft
    })
  }

  useEffect(() => {
    if (!activeCategoryId) return () => {}
    scrollTo(activeCategoryId)
  }, [activeCategoryId])

  return (
    <div
      className={styles.container}
      ref={container}
      onScroll={event => {
        if (event?.target && 'scrollLeft' in event.target) {
          const scrollLeft = event?.target['scrollLeft']
          setScrollLeft(scrollLeft as number)
        }
      }}>
      {categories.map(category => {
        const childProps = {
          ref: ref => (refs.current[category._id] = ref),
          key: category._id,
          className:
            activeCategoryId === category._id
              ? classnames(styles.active, 'primaryColor')
              : classnames(
                  styles.category,
                  global.isDarkBackground ? styles.clearText : styles.darkText
                )
        }

        return isStore ? (
          <Dropdown
            {...childProps}
            id={category._id}
            name={category.name}
            subCategories={category.subCategories}
            scrollLeft={scrollLeft}
          />
        ) : (
          <a
            {...childProps}
            onClick={() => {
              onClick()
              props.scrollTo(category._id)
            }}>
            {category.name}
          </a>
        )
      })}
    </div>
  )
}
